import React, { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";
import { sendData } from "../../../lib/dashboard/actions";
import { useEffect } from "react";

const DerivativesCommodityMarketContext = createContext();

const DerivativesCommodityMarketProvider = ({ children }) => {
    const [positions, setPositions] = useState([
        { name: "خرید", id: "long_future" },
        { name: "فروش", id: "short_future" },
    ]);
    const [isSaffronChecked, setIsSaffronChecked] = useState(true);
    const [searchParams] = useSearchParams();
    const positionParam = searchParams.get("position");
    const tableSortParam = searchParams.get("table-sort");
    const tableParam = searchParams.get("table");

    const [tableData, setTableData] = useState({
        data: [],
        isLoading: false,
        isValidating: false,
    });

    const [filteredTableData, setFilteredTableData] = useState({
        data: [],
        isLoading: false,
        isValidating: false,
    });

    //GET INCREASE RATE
    const increaseRate = useSWR(`/future/monthly-interest-rate`, fetchData, {
        dedupingInterval: 6000,
    });

    useEffect(() => {
        getFutureContractsTableData();
    }, [positionParam, tableParam]);

    useEffect(() => {
        if (!tableData?.data) return;

        let filteredItems = tableData.data;

        if (tableSortParam) {
            filteredItems = filteredItems.filter((data) =>
                data.base_equity_name.includes(tableSortParam)
            );
        }

        if (!isSaffronChecked) {
            filteredItems = filteredItems.filter(
                (data) =>
                    !data.base_equity_name.includes("زعفران") &&
                    !(data.symbol_name && data.symbol_name.includes("زعفران"))
            );
        }

        setFilteredTableData((prev) => ({
            ...prev,
            data: filteredItems,
        }));
    }, [tableSortParam, tableData, isSaffronChecked]);

    //GET TABLE DATA
    const getFutureContractsTableData = async () => {
        if (positionParam) {
            setTableData((prev) => ({ ...prev, isLoading: true }));
            const response = await sendData(
                { strategy_key: positionParam },
                `/future/positions`,
                `${searchParams.toString()}`
            );

            if (response?.data) {
                setTableData((prev) => ({
                    ...prev,
                    data: response.data,
                    isLoading: false,
                }));
                setFilteredTableData((prev) => ({
                    ...prev,
                    data: response.data,
                    isLoading: false,
                }));
            }
        }
    };

    return (
        <DerivativesCommodityMarketContext.Provider
            value={{
                tableData,
                setTableData,
                increaseRate,
                searchParams,
                positions,
                setPositions,
                filteredTableData,
                isSaffronChecked,
                setIsSaffronChecked
            }}
        >
            {children}
        </DerivativesCommodityMarketContext.Provider>
    );
};

export default DerivativesCommodityMarketProvider;

export function useDerivativesCommodityMarketContext() {
    return useContext(DerivativesCommodityMarketContext);
}
